// extracted by mini-css-extract-plugin
export default {"aboutus":"style_aboutus__2+5yk","textblock":"style_textblock__tNqnn","img":"style_img__aOj-7"};